var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form-item",
    { attrs: { label: _vm.i18nt("designer.setting.displayType") } },
    [
      _c(
        "el-select",
        {
          model: {
            value: _vm.optionModel.type,
            callback: function ($$v) {
              _vm.$set(_vm.optionModel, "type", $$v)
            },
            expression: "optionModel.type",
          },
        },
        [
          _c("el-option", { attrs: { label: "datetime", value: "datetime" } }),
          _vm._v(" "),
          _c("el-option", { attrs: { label: "date", value: "date" } }),
          _vm._v(" "),
          _c("el-option", { attrs: { label: "dates", value: "dates" } }),
          _vm._v(" "),
          _c("el-option", { attrs: { label: "year", value: "year" } }),
          _vm._v(" "),
          _c("el-option", { attrs: { label: "month", value: "month" } }),
          _vm._v(" "),
          _c("el-option", { attrs: { label: "week", value: "week" } }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }